import type { EditorPlugin } from '../../../types/aha-editor';
import { concatenateStyle } from '../utils';

const FontFamilyMarkPlugin: EditorPlugin = {
  name: 'Font family mark plugin',
  mark: {
    type: 'fontFamily',
    use: ({ leaf, props }) =>
      concatenateStyle({ ...props }, 'fontFamily', leaf.fontFamily),
  },
};
export default FontFamilyMarkPlugin;
